// extracted by mini-css-extract-plugin
module.exports = {"Header-container":"Header_Header-container__38OKR","Header-title":"Header_Header-title__3-3j1"};